// extracted by mini-css-extract-plugin
export var flexContainer = "tag-list-module--flex-container--oYKNg";
export var tagList = "tag-list-module--tag-list--JP8C-";